import React, { useRef, useEffect } from 'react'
import PropTypes from 'prop-types'

import { themeChoices, setTheme, themeSelector } from '../../themes'
import { Select } from './'
import { defaultVariant } from './common'

/**
 * Implements a multi MUI Select to select MUI themse.
 *
 * @param {object} props component props
 * @returns {SelectTheme} SelectTheme component
 */
const SelectTheme = props => {
  const selectRef = useRef(null)
  const onChange = value => {
    setTheme(value)
  }

  const noTranslate = props.label !== undefined
  const noTranslateItems = props.items !== undefined

  useEffect(() => {
    selectRef.current.setValue(themeSelector())
  }, [])

  return (
    <Select
      id='selectTheme'
      {...props}
      ref={selectRef} 
      onChange={onChange} 
      noTranslate={noTranslate} 
      label={props.label || 'global.changeTheme'} 
      noTranslateItems={noTranslateItems}
      items={props.items || themeChoices}
    />
  )
}

SelectTheme.propTypes = {
  /**
   id for the control.
   */
  id: PropTypes.string,
  /**
   Label to display for the control.
   */
  label: PropTypes.string,
  /**
   Style for the control.
   */
  style: PropTypes.object,
  /**
   MUI variant for the control.
   */
  variant: PropTypes.oneOf(['outlined', 'standard']),
  /**
   Determines if the control is disabled.
   */
  disabled: PropTypes.bool,
  /**
   Items to display in the radio group.
   */
  items: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string,
    label: PropTypes.string,
  })),
}

SelectTheme.defaultProps = {
  variant: defaultVariant,
}

export default SelectTheme